import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './utils/rem.js'
import GButton from './components/GButton'
import FootView from '@/components/Foot/index.vue'
import Paginate from '@/components/vuejs-paginate/Paginate.vue'

Vue.config.productionTip = false
Vue.component('GButton', GButton)
Vue.component('FootView', FootView)
Vue.component('PaginateView', Paginate)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
